export const selectCatalogueCategoryIds = (state) => state.catalogue.categoryIds;

export const selectCatalogueLoading = (state) => state.catalogue.loading;

export const selectCatalogueError = (state) => state.catalogue.error;

export const catalogueSelectors = {
    selectCatalogueCategoryIds,
    selectCatalogueLoading,
    selectCatalogueError,
};